import React, { useCallback, useState } from "react";

const idFront = "/images/id_front.png";
const idBack = "/images/id_back.png";

const IdCardPreview = ({ frontUrl, backUrl }) => {
  const [side, setSide] = useState("front");

  const handleShowFront = useCallback(() => setSide("front"), []);
  const handleShowBack = useCallback(() => setSide("back"), []);

  console.log("frontUrl", frontUrl);
  console.log("backUrl", backUrl);

  const isBack = side === "back";
  const cacheBuster = `?t=${Date.now()}`;
  const frontSrc = frontUrl ? `${frontUrl}${cacheBuster}` : idFront;
  const backSrc = backUrl ? `${backUrl}${cacheBuster}` : idBack;

  return (
    <div style={styles.container}>
      <div style={styles.cardWrapper}>
        <div
          style={{
            ...styles.cardInner,
            transform: isBack ? "rotateY(180deg)" : "rotateY(0)",
          }}
        >
          <div style={styles.cardFace}>
            <img src={frontSrc} alt="ID Front" style={styles.img} />
          </div>
          <div style={{ ...styles.cardFace, ...styles.cardFaceBack }}>
            <img src={backSrc} alt="ID Back" style={styles.img} />
          </div>
        </div>
      </div>
      <div style={styles.buttonRow}>
        <button
          disabled={side === "front"}
          onClick={handleShowFront}
          style={{
            ...styles.button,
            ...(side === "front" ? styles.buttonDisabled : styles.buttonActive),
          }}
        >
          Show Front
        </button>
        <button
          disabled={side === "back"}
          onClick={handleShowBack}
          style={{
            ...styles.button,
            ...(side === "back" ? styles.buttonDisabled : styles.buttonActive),
          }}
        >
          Show Back
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    margin: "20px auto",
    maxWidth: "320px",
  },
  cardWrapper: {
    width: "100%",
    perspective: "1000px",
  },
  cardInner: {
    position: "relative",
    width: "100%",
    paddingTop: "63%",
    transition: "transform 0.6s ease",
    transformStyle: "preserve-3d",
  },
  cardFace: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backfaceVisibility: "hidden",
  },
  cardFaceBack: {
    transform: "rotateY(180deg)",
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "8px",
    outline: "15px solid #fff",
    outlineOffset: "-15px",
  },
  buttonRow: {
    display: "flex",
    gap: "12px",
  },
  button: {
    height: "32px",
    minWidth: "120px",
    border: "1px solid",
    borderRadius: "0",
    cursor: "pointer",
    fontSize: "14px",
    padding: "0 12px",
  },
  buttonActive: {
    backgroundColor: "#fff",
    borderColor: "#0f62fe",
    color: "#0f62fe",
    cursor: "pointer",
  },
  buttonDisabled: {
    backgroundColor: "#c6c6c6",
    borderColor: "#c6c6c6",
    color: "#fff",
    cursor: "not-allowed",
  },
};

export default IdCardPreview;
